/* Nordelle SE — social proof-komponenter (v29) */
(function () {
  'use strict';

  /* ---------- 6. UGC-remsa: spela i bild, ljud av/på ---------- */
  function initUgc() {
    var tracks = document.querySelectorAll('[data-sp-ugc]');
    if (!tracks.length) return;
    var vids = [];
    tracks.forEach(function (t) {
      t.querySelectorAll('video').forEach(function (v) {
        v.muted = true;
        v.setAttribute('muted', '');
        v.setAttribute('playsinline', '');
        v.removeAttribute('controls');
        vids.push(v);
      });
    });
    var reduced = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    if (!reduced && 'IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          if (e.isIntersecting) {
            var p = e.target.play();
            if (p && p.catch) p.catch(function () {});
          } else {
            e.target.pause();
          }
        });
      }, { threshold: 0.5 });
      vids.forEach(function (v) { io.observe(v); });
    }

    function setBtn(btn, on) {
      btn.setAttribute('aria-pressed', on ? 'true' : 'false');
      btn.setAttribute('aria-label', on ? 'Mute sound' : 'Turn sound on');
    }
    document.querySelectorAll('[data-sp-sound]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var item = btn.closest('.sp-ugc__item');
        var v = item ? item.querySelector('video') : null;
        if (!v) return;
        var turnOn = v.muted;
        vids.forEach(function (o) {
          o.muted = true;
          var b = o.closest('.sp-ugc__item').querySelector('[data-sp-sound]');
          if (b) setBtn(b, false);
        });
        if (turnOn) {
          v.muted = false;
          var p = v.play();
          if (p && p.catch) p.catch(function () {});
          setBtn(btn, true);
        }
      });
    });
  }

  /* ---------- 5. landsfilter i recensionsväggen ---------- */
  function initReviewFilter() {
    document.querySelectorAll('[data-sp-rw-filter]').forEach(function (bar) {
      var section = bar.closest('section');
      if (!section) return;
      var cards = section.querySelectorAll('.review-wall__card');
      var more = section.querySelector('[data-review-more]');
      bar.addEventListener('click', function (e) {
        var chip = e.target.closest('[data-sp-country]');
        if (!chip) return;
        var c = chip.getAttribute('data-sp-country');
        bar.querySelectorAll('[data-sp-country]').forEach(function (b) {
          b.setAttribute('aria-pressed', b === chip ? 'true' : 'false');
        });
        cards.forEach(function (card) {
          if (c !== 'all') card.classList.remove('is-hidden');
          card.classList.toggle('sp-out', c !== 'all' && card.getAttribute('data-country') !== c);
        });
        if (more && c !== 'all' && more.parentElement) more.parentElement.hidden = true;
      });
    });
  }

  /* ---------- 9. köpnotis från verkliga ordrar ---------- */
  function initToast() {
    var el = document.querySelector('[data-sp-toast]');
    var dataEl = document.querySelector('[data-sp-recent]');
    if (!el || !dataEl) return;
    try { if (sessionStorage.getItem('sp_toast_closed') === '1') return; } catch (e) {}

    var list;
    try { list = JSON.parse(dataEl.textContent); } catch (e) { return; }
    if (!Array.isArray(list)) return;

    var maxAge = (parseFloat(el.getAttribute('data-max-age')) || 48) * 3600000;
    var now = Date.now();
    list = list
      .map(function (o) {
        return { city: String(o.city || '').trim(), qty: parseInt(o.qty, 10) || 1, t: Date.parse(o.ts) };
      })
      .filter(function (o) { return !isNaN(o.t) && o.t <= now && now - o.t <= maxAge; })
      .sort(function (a, b) { return b.t - a.t; })
      .slice(0, 8);
    if (!list.length) return;

    var tpl = el.getAttribute('data-template') || 'Someone in [stad] bought [antal]';
    var titleEl = el.querySelector('[data-sp-toast-title]');
    var timeEl = el.querySelector('[data-sp-toast-time]');
    var closeBtn = el.querySelector('[data-sp-toast-close]');
    var timers = [];
    var i = 0;

    function ago(t) {
      var m = Math.max(1, Math.round((Date.now() - t) / 60000));
      if (m < 60) return m + (m === 1 ? ' minute' : ' minutes') + ' ago';
      var h = Math.round(m / 60);
      if (h < 24) return (h === 1 ? 'an hour' : h + ' hours') + ' ago';
      var d = Math.round(h / 24);
      return (d === 1 ? 'a day' : d + ' days') + ' ago';
    }
    function text(o) {
      var s = o.city ? tpl.replace('[stad]', o.city) : tpl.replace(/\s*(?:i|in|paikkakunnalta) \[stad\]/, '').replace('[stad]', '');
      return s.replace('[antal]', o.qty);
    }
    function later(fn, ms) { timers.push(setTimeout(fn, ms)); }
    var sticky = document.querySelector('[data-sticky-atc]');
    function coversMainCta() {
      /* på mobil: vänta tills köpboxen scrollats förbi, så notisen aldrig täcker huvudknappen */
      return window.innerWidth < 750 && sticky && !sticky.classList.contains('is-visible');
    }
    function show() {
      if (i >= list.length) return;
      if (coversMainCta()) { later(show, 2500); return; }
      var o = list[i];
      titleEl.textContent = text(o);
      timeEl.textContent = ago(o.t);
      el.hidden = false;
      requestAnimationFrame(function () { el.classList.add('is-in'); });
      later(function () {
        el.classList.remove('is-in');
        i += 1;
        later(show, 9000);
      }, 5500);
    }
    if (closeBtn) {
      closeBtn.addEventListener('click', function () {
        timers.forEach(clearTimeout);
        el.classList.remove('is-in');
        el.hidden = true;
        try { sessionStorage.setItem('sp_toast_closed', '1'); } catch (e) {}
      });
    }
    later(show, (parseFloat(el.getAttribute('data-delay')) || 8) * 1000);
  }

  function run() {
    initUgc();
    initReviewFilter();
    initToast();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', run);
  else run();
})();
